import React, { useContext, useEffect } from 'react';
import I18n from 'i18n-js';
import Modal from '@reverbdotcom/commons/src/components/modal';
import { RCMenu } from '@reverbdotcom/cadence/components';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

import BumpV2ModalContainer, { BumpV2ModalContainerProps } from '../../bump/bump_v2_modal_container';
import { formatBid } from '../../bump/bump_helpers';
import SellerListingsCollectionContext from '../SellerListingsCollectionContext';
import SellerListingCardContext from '../SellerListingCardContext';
import { ActionType } from '../sellerListingCardReducer';
import {
  bumpRecommendationsController,
  BumpControllerProps,
} from '../../bump/bump_controller';

export const COMPONENT_NAME = 'BumpButton';

interface BumpButtonV2Props {
  listing: any;
  setShowModal: (showModal) => void;
}

export function BumpButtonV2({
  listing,
  setShowModal,
}: BumpButtonV2Props) {

  function handleClick() {
    setShowModal(true);
    trackEvent({
      eventName: MParticleEventName.ClickedComponent,
      componentName: COMPONENT_NAME,
      listingId: listing.id,
    });
  }

  return (
    <>
      <RCMenu.Item onClick={() => handleClick()}>
        {listing.bumpRate?.rate ? I18n.t('discovery.bumpButton.manageBump') : I18n.t('discovery.bumpButton.bumpItem')}
      </RCMenu.Item>
    </>
  );
}

interface BumpV2ModalProps extends BumpV2ModalContainerProps {
  showModal: boolean;
  setShowModal: (showModal) => void;
}

export function BumpModalV2({
  showModal,
  setShowModal,
  bid,
  listingId,
  selectedBid,
  handleBidChange,
  updateBid,
  successMessage,
  failMessage,
}: BumpV2ModalProps) {

  const { dispatch } = useContext(
    SellerListingCardContext,
  );

  const {
    useLazySellerListingsQuery,
  } = useContext(SellerListingsCollectionContext);

  const { refetchSellerListings } = useLazySellerListingsQuery();

  useEffect(() => {
    if (successMessage) {
      const message = bid
        ? I18n.t('discovery.bump.successListingRow', {
          percent: formatBid(bid),
        })
        : I18n.t('discovery.bump.successBidDelete');

      refetchSellerListings([listingId]);

      dispatch({
        type: ActionType.SHOW_TOAST,
        payload: {
          isSuccess: true,
          message,
        },
      });
    }
  }, [successMessage]);

  return (
    <Modal
      isOpen={showModal}
      headerTitle={I18n.t('discovery.bumpModal.title')}
      onRequestClose={() => {
        setShowModal(false);
      }}
      paddedBody
      shouldCloseOnOverlayClick
    >
      <BumpV2ModalContainer
        bid={bid}
        listingId={listingId}
        selectedBid={selectedBid}
        handleBidChange={handleBidChange}
        updateBid={updateBid}
        successMessage={successMessage}
        failMessage={failMessage}
        refetch={() => {}}
        onRequestClose={() => {
          setShowModal(false);
        }}
      />
    </Modal>
  );
}

const BumpModalV2WithController =
  bumpRecommendationsController(BumpModalV2);

export default (props: BumpControllerProps) => {
  return (
    <BumpModalV2WithController
      componentName={COMPONENT_NAME}
      listingId={props.listingId}
      bid={props.bid}
      showModal={props.showModal}
      setShowModal={props.setShowModal}
      refetch={() => {}}
    />
  );
};
